import * as React from 'react';
import { CustomSlider, Settings } from '../../../packages';

import { Arrow } from './slick/Arrow';
import { Card } from './Card';

import { ICard } from '../../types/types';
import './slick/slickCustomStyles.css';
import * as styles from './styles.css';

interface IProps {
  content: ICard[];
}

const slickSettings: Settings = {
  dots: true,
  infinite: true,
  autoplay: false,
  slidesToShow: 2,
  slidesToScroll: 2,
  adaptiveHeight: true,
  nextArrow: <Arrow />,
  prevArrow: <Arrow rotated />,
};

export const DesktopView: React.FC<IProps> = props => {
  return (
    <CustomSlider {...slickSettings} className="analytics-slider">
      {props.content.map((slide, i) => {
        return (
          <Card
            key={i}
            className={styles['block-card-item']}
            title={slide.title}
            titleIcon={slide.titleIcon}
            content={slide.content}
          />
        );
      })}
    </CustomSlider>
  );
};
